module.exports = __webpack_public_path__ + "static/media/npo-connect-landscape.201cc0fc.png";